import { render } from "./CattleDetails.vue?vue&type=template&id=54e387d8&scoped=true"
import script from "./CattleDetails.vue?vue&type=script&lang=js"
export * from "./CattleDetails.vue?vue&type=script&lang=js"

import "./CattleDetails.vue?vue&type=style&index=0&id=54e387d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e387d8"]])

export default __exports__